import React, { useEffect } from "react";
import "./banner/Banner.css";
import Free_eye from "./free-eye-checkup/Free_eye";
import Banner from "./banner/Banner";
import Trending_now from "./trending-now/Trending_now";
import Top_frames from "./top-frames/Top_frames";
import Define_style from "./define-style/Define_style";
import Offer_banner from "./offer-banner/Offer_banner";
import Zoe_miller_slider from "./zoe-miller-slider/Zoe_miller_slider";
import Men_women_kids from "./men-women-kids/Men_women_kids";
import Timeless_design from "./timeless-design/Timeless_design";
import Free_checkup from "./free-checkup/Free_checkup";
import All_offers from "./all-offers/All_offers";
import Testimonials from "./testimonials/Testimonials";
import Faq from "./faq/Faq";
import Brands from "./brands/Brands";
import Newslater from "./newslater/Newslater";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllGender,
} from "../../features/master/masterSlice";
import {
  getAllBanner,
  getCoupons,
  getHomeBanner,
  getTrendingProduct,
} from "../../features/home/homeSlice";
import {
  getAllEyeGlasses,
  getAllOURProduct,
  getAllProducts,
  getAllTopProducts,
  getAllTrandingProducts,
} from "../../features/products/productsSlice";
import { getFaq } from "../../features/faq/Slice";
import { getAllCustomerRatings } from "../../features/rating/ratingSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import Define_style_EyeGlasses from "./define-style/Define_style";

function Home({ handleFilterChange }) {
  console.log('Reached Home');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();
  const banners = useSelector((state) => state.home.banners);

  const categories = useSelector((state) => state.master.categories);

  useEffect(() => {
    dispatch(getAllCategories());
  }, []);
  useEffect(() => {
    dispatch(getHomeBanner());
  }, []);

  const products = useSelector((state) => state.product.allOurProducts);
  // const trandingProducts = useSelector(
  //   (state) => state.product.allProductsTranding
  // );
  const topProducts = useSelector((state) => state.product.allProductsTop);

  const EyeglassesProducts = useSelector((state) => state.product.eyeglasses_product);


  const trendingProduct = useSelector((state) => state.home.trending_product);

  useEffect(() => {
    dispatch(getAllOURProduct({ category_id: 2 }));
    dispatch(getAllEyeGlasses({ category_id: 5 }));
    // dispatch(getAllTrandingProducts({}));
    dispatch(getAllTopProducts({}));
     dispatch(getTrendingProduct({}));
  }, []);

  const faqs = useSelector((state) => state.faq.getfaq);

  useEffect(() => {
    dispatch(getFaq());
  }, [dispatch]);

  const allreview = useSelector((state) => state.rating.customer_ratings);

  useEffect(() => {
    dispatch(getAllCustomerRatings());
  }, [dispatch]);
  const is_signin = useSelector((state) => state.auth.is_signin);
  useEffect(() => {
    if (is_signin) {
      dispatch(getAllWishlist());
    }
  }, [dispatch]);

  const allGender = useSelector((state) => state.master.all_gender);

  useEffect(() => {
    dispatch(getAllGender());
  }, [dispatch]);

  console.log(EyeglassesProducts,"EyeglassesProducts EyeglassesProducts");
  
  return (
    <>
      <Free_eye />
      {banners?.length > 0 && (
        <Banner
          banners={banners}
          categories={categories}
          handleFilterChange={handleFilterChange}
        />
      )}

      {trendingProduct?.length > 0 && (
        <Trending_now products={trendingProduct} />
      )}
      {topProducts?.length > 0 && <Top_frames products={topProducts} />}

      {/* {products?.data?.length > 0 && <Define_style products={products} name={'sunglasses'} />} */}
      <Offer_banner />

      {EyeglassesProducts?.data?.length > 0 && <Define_style_EyeGlasses products={EyeglassesProducts} name={'eyeglasses'} />}
      {/* {products?.data?.length > 0 && <Zoe_miller_slider products={products} />} */}
      <Men_women_kids allGender={allGender} />
      <Timeless_design />
      <Free_checkup />
      <All_offers />
      {allreview?.length > 0 && <Testimonials allreview={allreview} />}

      {faqs?.length > 0 && <Faq faqItems={faqs} />}

      <Brands />
      <Newslater />
    </>
  );
}

export default Home;
